import React from 'react'
import PropTypes from 'prop-types'

const CrossedCircle = ({ className, width, height, fill = '#173A56' }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.63 15.55 4 13.85 4 12ZM7.1 18.31C8.45 19.37 10.15 20 12 20C16.42 20 20 16.42 20 12C20 10.15 19.37 8.45 18.31 7.1L7.1 18.31Z"
      fill={fill}
    />
  </svg>
)

CrossedCircle.defaultProps = {
  width: '24',
  height: '24',
  className: '',
}

CrossedCircle.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
}

export default CrossedCircle
